import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from 'src/app/typings/typing';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  prefix = '/sysLog';

  constructor(private http: HttpClient) { }

  getTableList(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryPage', params);
  }
}
